import { render, staticRenderFns } from "./screening-review-notice.vue?vue&type=template&id=558c388b&scoped=true"
import script from "./screening-review-notice.vue?vue&type=script&lang=js"
export * from "./screening-review-notice.vue?vue&type=script&lang=js"
import style0 from "./screening-review-notice.vue?vue&type=style&index=0&id=558c388b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c388b",
  null
  
)

export default component.exports